// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_r9EXP{display:flex;flex-direction:column;margin-top:-20px}.answerList_WqBnJ{padding-left:10px}.answer_wDPiw{font-weight:400;list-style:circle}", ""]);
// Exports
exports.locals = {
	"root": "root_r9EXP",
	"answerList": "answerList_WqBnJ",
	"answer": "answer_wDPiw"
};
module.exports = exports;
